import React, { Fragment, memo, useState } from "react";

import { CourceClinic } from './CourceClinic';

export const CourceClinicList = memo((props) => {
  const { items, options } = props;

  return (
    <>
      <table className="table table-bordered table-hover table-condensed">
          <thead>
            <tr>
              <th style={{ width: 90 + 'px' }}>ID</th>
              <th style={{ width: 90 + 'px' }}>医療ID</th>
              <th>医療機関名</th>
              <th><i className="fas fa-filter" /> OP設定</th>
            </tr>
        </thead>
        <tbody>
          {items.map(item =>
            <CourceClinic key={item.id} item={item} options={options} />
          )}
        </tbody>
      </table>
    </>
  );
});
